<script>
  import { createEventDispatcher } from 'svelte';
  import { onMount } from 'svelte';

	const dispatch = createEventDispatcher();

  let videoFile;
  export let data;
  export let pauseVideo = false;
  let paused;
  $: {
    if(pauseVideo){
      paused = false;
    } else {
      paused = true;
    }
    // console.log("paused",paused);
  }
  export let klass = "";

  const redX = (Math.random() - 0.5) * 20 + 50;
  const redY = Math.random() * 20;
  const greenX = 70 + Math.random() * 20;
  const greenY = (Math.random() - 0.5) * 2 + Math.random() * 20 + 18;
  const orangeX = (Math.random() - 0.5) * 2 + Math.random() * 20 + 52;
  const orangeY = 80 + Math.random() * 20;
  const blueX = (Math.random() - 0.5) * 2 + Math.random() * 20 + 20;
  const blueY = 90 + Math.random() * 10;
  const pinkX = Math.random() * 20 + 10;
  const pinkY = (Math.random() - 0.5) * 2 + Math.random() * 20 + 18;

  const random10 = Math.random() * 10;
  const random20 = Math.random() * 20;
  const random30 = Math.random() * 30;
  const randomPositiveNegative = (Math.random() - 0.5) * 2;

  let options = {
    rootMargin: '-100px',
    threshold: 1.0
  }

  onMount(() => {
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            paused = false;
            // video.target.classList.remove("lazy");
            videoFile = null;
            lazyVideoObserver.unobserve(video.target);
          }
        });
      }, options);

      lazyVideoObserver.observe(videoFile);
    }
  });

  // const clip1 = `polygon(${redX}% ${redY}%, ${greenX}% ${greenY}%, ${orangeX}% ${orangeY}%, ${blueX}% ${blueY}%, ${pinkX}% ${pinkY}%)`;

</script>

<div class="{klass}" style="--bg: {data.color}; --randomPositiveNegative: {randomPositiveNegative}; --random10: {random10}; --random20: {random20}; --random30: {random30}; --redX: {redX}; --redY: {redY}; --greenX: {greenX}; --greenY: {greenY}; --orangeX: {orangeX}; --orangeY: {orangeY}; --blueX: {blueX}; --blueY: {blueY}; --pinkX: {pinkX}; --pinkY: {pinkY};">
  <video 
  style="background-image: url('../video/cover/{data.id}.jpg');"
  bind:this={videoFile} 
  class="clip1 lazy"
  poster="../video/cover/{data.id}.jpg"
  preload="none"
  muted loop autoplay playsinline 
  bind:paused 
  on:click={()=>{dispatch('clickPost',{id: data.id})}} >
    <source data-src="../video/very-small/{data.id}.mp4" type="video/mp4">
    <source data-src="../video/very-small/{data.id}.webm" type="video/webm">
  </video>
  <!--<video class="clip2" src="../video/v{cover}.mp4" type="video/mp4" muted loop />
  <video class="clip3" src="../video/v{cover}.mp4" type="video/mp4" muted loop />-->
</div>

<style type="text/scss">
  // @keyframes suttleRotate {
  //  0%     { transform: translateZ(calc(var(--randomPositiveNegative) * 10px + 2px ))  scale(calc(1 + (var(--random10) / 30))) rotate3d(1,1,1,0deg) }
  //  60%    { transform: translateZ(calc(var(--randomPositiveNegative) * 10px + 2px ))  scale(calc(1 + (var(--random10) / 30))) rotate3d(1,1,1, calc(1 + (var(--random10) / 5))) }
  //  100%   { transform: translateZ(calc(var(--randomPositiveNegative) * 10px + 2px ))  scale(calc(1 + (var(--random10) / 30))) rotate3d(1,1,1,0deg) }
  // }
  // @keyframes clip2 {
  //   0% {    clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--pinkX) * 1% + 20%) calc(var(--greenY) * 1%), calc(var(--blueX) * 1% + 10%) calc(var(--orangeY) * 1% - 20%), calc(var(--blueX) * 1%) calc(var(--blueY) * 1%), calc(var(--pinkX) * 1%) calc(var(--pinkY) * 1%)); }
  //   50% {   clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--pinkX) * 1% + 40%) calc(var(--greenY) * 1% + var(--random20) * 1%), calc(var(--blueX) * 1% + var(--random30) * 1%) calc(var(--orangeY) * 1% - 5%), calc(var(--blueX) * 1%) calc(var(--blueY) * 1%), calc(var(--pinkX) * 1%) calc(var(--pinkY) * 1%)); }
  //   100% {  clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--pinkX) * 1% + 20%) calc(var(--greenY) * 1%), calc(var(--blueX) * 1% + 10%) calc(var(--orangeY) * 1% - 20%), calc(var(--blueX) * 1%) calc(var(--blueY) * 1%), calc(var(--pinkX) * 1%) calc(var(--pinkY) * 1%)); }
  // }
  // @keyframes clip3 {
  //   0% {    clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--greenX) * 1%) calc(var(--greenY) * 1%), calc(var(--orangeX) * 1%) calc(var(--orangeY) * 1%), calc(var(--orangeX) * 1% - 10%) calc(var(--blueY) * 1%), calc(var(--greenX) * 1% - 10%) calc(var(--pinkY) * 1%)); }
  //   50% {   clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--greenX) * 1%) calc(var(--greenY) * 1%), calc(var(--orangeX) * 1%) calc(var(--orangeY) * 1%), calc(var(--orangeX) * 1% - var(--random30) * 1%) calc(var(--blueY) * 1% - var(--random20) * 1%), calc(var(--greenX) * 1% - var(--random30) * 1%) calc(var(--pinkY) * 1% + var(--random20) * 1%)); }
  //   100% {  clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--greenX) * 1%) calc(var(--greenY) * 1%), calc(var(--orangeX) * 1%) calc(var(--orangeY) * 1%), calc(var(--orangeX) * 1% - 10%) calc(var(--blueY) * 1%), calc(var(--greenX) * 1% - 10%) calc(var(--pinkY) * 1%)); }
  // }
  div {
    transform-origin: center center;
    position: relative; 
    filter: drop-shadow(0 0 4px var(--bg)) drop-shadow(0 0 50px var(--bg));
    box-sizing: border-box;
    min-width: 150px;
    min-height: 100px;
    max-height: 10vh;
    overflow: visible;
    // animation: suttleRotate 20s ease-in-out infinite alternate forwards;
    transform: translateZ(calc(var(--randomPositiveNegative) * 10px + 2px )) scale3d(1.5,1.5,1) rotate3d(1,1,1,0deg);
    transition: all 400ms ease-in-out;
    &:hover {
      transform: translateZ(calc(var(--randomPositiveNegative) * 10px + 2px )) scale3d(1.7,1.7,1) rotate3d(1,1,1,0deg);
      filter: drop-shadow(0 0 3px var(--bg)) drop-shadow(0 0 30px var(--bg));
      transition: all 400ms ease-in-out;
    }
  }
  video {
    background-position: center center;
    background-size: contain;
    cursor: pointer;
    width: 100%;
    height: 100%;
    transform: translateZ(0);
  }
  // .clip2, .clip3 {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   // transform: rotate3d(1, 1, 1, -2deg) translate3d(-150px, -100px,-40px);
  // }
  .clip1 {
		clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--greenX) * 1%) calc(var(--greenY) * 1%), calc(var(--orangeX) * 1%) calc(var(--orangeY) * 1%), calc(var(--blueX) * 1%) calc(var(--blueY) * 1%), calc(var(--pinkX) * 1%) calc(var(--pinkY) * 1%));
  }
  // .clip2 {
	// 	clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--pinkX) * 1% + 20%) calc(var(--greenY) * 1%), calc(var(--blueX) * 1% + 10%) calc(var(--orangeY) * 1% - 20%), calc(var(--blueX) * 1%) calc(var(--blueY) * 1%), calc(var(--pinkX) * 1%) calc(var(--pinkY) * 1%));
  //   transform: rotate3d(1, 1, 1, -2deg) translate3d(calc(-1% * var(--random10)), calc(-1% * var(--random20)), -40px) scale(0.9);
  //   animation: clip2 9s ease-in-out alternate; // infinite
  // }
  // .clip3 {
  //   clip-path: polygon(calc(var(--redX) * 1%) calc(var(--redY) * 1%), calc(var(--greenX) * 1%) calc(var(--greenY) * 1%), calc(var(--orangeX) * 1%) calc(var(--orangeY) * 1%), calc(var(--orangeX) * 1% - 10%) calc(var(--blueY) * 1%), calc(var(--greenX) * 1% - 10%) calc(var(--pinkY) * 1%));
  //   transform: rotate3d(1, 1, 1, -2deg) translate3d(calc(-0.4% * var(--random20)), calc(0.5% * var(--random30)), -90px) scale(0.85);
  //   animation: clip3 10s ease-in-out alternate; // infinite
  // }
</style>